<div id="chatMessages" class="conversation">

    <div class="message-list" id="message-list">
        <div *ngFor="let msg of allMessages" class="message-bubble" [class.me]="msg.senderId === authenticatedUserId"
            [innerHTML]="msg.content | nl2br">
        </div>
    </div>

    <div *ngIf="allMessages.length === 0 && targetUser" class="empty-state">
        <p>Aucun message avec {{ targetUser.firstName }} {{ targetUser.lastName }}. Lancez la conversation ! 👋</p>
    </div>

    <div class="input-area">
        <textarea #messageInput [(ngModel)]="newMessage" [disabled]="!targetUser"
            placeholder="Écrivez un message ici" rows="1" (keydown)="onInputKeydown($event)"></textarea>
    </div>

</div>
